export interface IOverlayMenuItemProps
{
	label: React.ReactNode;
	icon: React.ReactNode;
	onClick: () => void;
	"data-name": string;
	className?: string;
	style?: React.CSSProperties;
}

const OverlayMenuItem = (props: IOverlayMenuItemProps) => 
{
	return (
		<div className={["viewportMenuItem", props.className].join(" ")}
			data-name={"overlay-menu-item-" + props["data-name"]}
			style={props.style}
			onClick={props.onClick}
		>
			{props.icon}
			{props.label}
		</div>
	);
};

export default OverlayMenuItem;